import { render } from "./NewsAddModal.vue?vue&type=template&id=26998fca&scoped=true"
import script from "./NewsAddModal.vue?vue&type=script&lang=js"
export * from "./NewsAddModal.vue?vue&type=script&lang=js"

import "./NewsAddModal.vue?vue&type=style&index=0&id=26998fca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26998fca"]])

export default __exports__